// src/components/faq/FaqAccordion.jsx
import React, { useState } from "react";
import "../../styles/components/FaqAccordion.css";

const items = [
  { 
    q: "How long does it take to develop a product?",
    a: "Timelines vary depending on the project scope. However, AI-assisted delivery can significantly reduce the time required for an MVP." 
  },
  { 
    q: "Do you work with startups or only established companies?",
    a: "We work with both: for startups we focus on fast MVPs and proofs of concept, while for enterprises we ensure proper processes, security, and scalability." 
  },
  { 
    q: "What about the security of AI-generated code?",
    a: "We follow strict security practices including SCA, SAST, secret scanning, license compliance, and human code reviews — all under clearly defined data policies." 
  },
  { 
    q: "Can you integrate with existing teams and workflows?",
    a: "Yes. We adapt to Jira, Linear, GitHub, GitLab, GitFlow or trunk-based workflows, and CI/CD pipelines. We can operate as an autonomous squad or as an extension of your team." 
  }
];

export default function FaqAccordion() {
  const [open, setOpen] = useState(() => new Set());

  const toggle = (i) => {
    const s = new Set(open);
    s.has(i) ? s.delete(i) : s.add(i);
    setOpen(s);
  };

  return (
    <section className="faq" aria-label="FAQ">
      <div className="faq__wrap">
        {items.map((it, i) => {
          const isOpen = open.has(i);
          const tone = i % 2 === 0 ? "tone-a" : "tone-b"; // 1&3 = A, 2&4 = B
          return (
            <div
  key={i}
  className={`faq-item faq-anim ${tone} ${isOpen ? "is-open" : ""}`}
>
              <button
                id={`faq-btn-${i}`}
                className="faq-item__btn"
                aria-expanded={isOpen}
                aria-controls={`faq-panel-${i}`}
                onClick={() => toggle(i)}
              >
                <span className="faq-item__q">{it.q}</span>
                <span className="faq-item__icon" aria-hidden="true">
                  <svg width="28" height="28" viewBox="0 0 24 24">
                    <rect x="4" y="11" width="16" height="2" rx="1"></rect>
                    <rect className="v-line" x="11" y="4" width="2" height="16" rx="1"></rect>
                  </svg>
                </span>
              </button>

              <div
                id={`faq-panel-${i}`}
                role="region"
                aria-labelledby={`faq-btn-${i}`}
                className="faq-item__panel"
                style={{ maxHeight: isOpen ? "320px" : "0px" }}
              >
                <div className="faq-item__a">{it.a}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
